import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M27.746 2.825C26.18 1.077 23.98.065 21.546 0c-2.614-.043-5.112.949-6.932 2.772L11.63 5.778c-.37.373-.571.875-.571 1.397s.2 1.023.582 1.407a1.97 1.97 0 0 0 2.783 0l2.984-3.006a5.53 5.53 0 0 1 3.894-1.62h.148c1.334.042 2.54.575 3.376 1.513a4.97 4.97 0 0 1 1.249 3.305 4.92 4.92 0 0 1-1.44 3.486l-3.27 3.295c-.37.373-.571.874-.571 1.407a2 2 0 0 0 .572 1.407c.38.384.888.576 1.386.576s1.005-.192 1.396-.576l3.27-3.294a8.86 8.86 0 0 0 2.593-6.29 8.97 8.97 0 0 0-2.254-5.96zM15.567 21.397l-2.995 3.017c-1.037 1.044-2.508 1.673-4.021 1.61-1.334-.033-2.53-.576-3.365-1.514a4.96 4.96 0 0 1-1.25-3.327 4.85 4.85 0 0 1 1.43-3.475l3.27-3.294c.37-.373.57-.875.57-1.397a2.02 2.02 0 0 0-.57-1.407c-.741-.746-2.043-.746-2.784 0l-3.27 3.294C.9 16.6-.02 18.838 0 21.204c0 2.218.794 4.33 2.244 5.96C3.81 28.924 6 29.925 8.424 29.99h.243a9.42 9.42 0 0 0 6.667-2.771l2.994-3.028c.762-.768.773-2.037 0-2.804a1.97 1.97 0 0 0-2.783 0z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.62 20.448c0 .522.2 1.023.57 1.407.382.384.89.565 1.387.565s1.016-.192 1.397-.565l10.825-10.906a2.005 2.005 0 0 0 0-2.804c-.751-.746-2.042-.746-2.783 0L8.191 19.051c-.37.373-.572.874-.572 1.407z"
    }, null, -1)
  ]))]))
}
export default { render: render }